export function newsFilter() {
  document.addEventListener("DOMContentLoaded", function () {
    var categoryFilter = document.getElementById("category-filter");
    var newsList = document.getElementById("news-list");
    var newsArticles = document.querySelectorAll(".news-article");

    if (categoryFilter) {
      categoryFilter.addEventListener("change", function () {
        var selectedCategory = categoryFilter.value;
        newsList.innerHTML = "";

        newsArticles.forEach(function (article) {
          if (
            selectedCategory === "all" ||
            article.getAttribute("data-category") === selectedCategory
          ) {
            article.classList.add("visible");
            newsList.appendChild(article);
          } else {
            article.classList.remove("visible");
          }
        });
      });
    }
  });
}
